/*
 * Custom hook for FullPageLoader Component
 *
 */

import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../actions/index";

export default function useFullPageLoader() {
  const dispatch = useDispatch();
  return [() => dispatch(showLoader()), () => dispatch(hideLoader())];
}
